import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest } from '../config/axios-config';

const getLocationDetails = (zipcode) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getLocationDetails +
          `?zipcode=${zipcode}`
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export { getLocationDetails };
